const PUBLIC_DESTINATIONS = {
  home: "/",
  about: "/about",
  contact: "/contact",
  pricing: "/#pricing",
  sign_in: "/studio",
};

export function registerWebMCP() {
  const modelContext = navigator.modelContext;
  if (!modelContext?.provideContext) return;

  modelContext.provideContext({
    tools: [
      {
        name: "navigate_nextvisit",
        description:
          "Navigate to a public NextVisit page or the human-controlled sign-in page.",
        inputSchema: {
          type: "object",
          properties: {
            destination: {
              type: "string",
              enum: Object.keys(PUBLIC_DESTINATIONS),
              description: "The NextVisit page to open.",
            },
          },
          required: ["destination"],
          additionalProperties: false,
        },
        execute: async ({ destination }) => {
          const path = PUBLIC_DESTINATIONS[destination];
          if (!path) throw new Error("Unknown NextVisit destination");
          window.location.assign(path);
          return {
            content: [
              {
                type: "text",
                text: `Opened the NextVisit ${destination.replace("_", " ")} page.`,
              },
            ],
          };
        },
      },
      {
        name: "get_nextvisit_capabilities",
        description:
          "Describe NextVisit's public capabilities without accessing private customer data.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false,
        },
        execute: async () => ({
          content: [
            {
              type: "text",
              text:
                "NextVisit sends post-visit thank-you, review, rebook, and win-back messages for appointment-based businesses and connects with Square Appointments.",
            },
          ],
        }),
      },
    ],
  });
}
